import { SelectItem } from '@/_components';
import { countries } from 'countries-list';

/**
 * Supported countries for the application. In each object,
 * - `name`: ISO 3166 name
 * - `value`: ISO 3166 alpha-2 code
 */
export const COUNTRY_ITEMS: Array<SelectItem> = Object.entries(countries)
  .map(([isoAlpha2Code, country]) => ({
    name: country.name,
    value: isoAlpha2Code,
  }))
  .sort((a, b) => a.name.localeCompare(b.name));
